const Layout = () => import('@/layout/index.vue');
const dynamicRoutes = [
//     {
//   path: "/",
//   component: Layout,
//   redirect: "/home",
//   meta: {
//     title: "首页",
//     visible: true,
//   }, children: [
//     {
//       path: "/home",
//       component: () => import("@/views/ZHome/index.vue"),
//       meta: {
//         title: "首页",
//         visible: true,
//         icon: 'HomeOutlined'
//       }
//     },
//
//   ]
// },
]

const dynamicRoutes1 = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    meta: {
      title: "首页",
      visible: true,
    }, children: [
      {
        path: "/home",
        component: () => import("@/views/ZHome/index.vue"),
        meta: {
          title: "首页",
          visible: true,
          icon: 'HomeOutlined'
        }
      },

    ]
  },
  {
    path: "/mobile-warning",
    component: Layout,
    meta: {
      title: "温馨提示",
      visible: false,
    }, children: [
      {
        path: "/mobile-warning",
        component: () => import("@/layout/ZMobileWarning.vue"),
        meta: {
          title: "温馨提示",
          visible: true,
          // icon: 'HomeOutlined'
        }
      },

    ]
  },
  {
    path: "/demo",
    component: () => import("@/views/ZDemo/index.vue"),
    meta: {
      title: "DEMO",
      visible: false,
      icon: 'HomeOutlined'
    }
  },
  // 在线联系
  {
    path: "/practice",
    component: Layout,
    meta: {
      title: "在线练习",
      visible: true,
      icon: 'ContainerOutlined'
    },
    children: [
      {
        path: "/general",
        meta: {
          title: "普测练习",
          visible: true
        },
        component: () => import("@/views/ZPractise/ZGeneral.vue")
      }, {
        path: "/collage-entrance",
        meta: {
          title: "高考练习",
          visible: true
        },
        component: () => import("@/views/ZPractise/ZCollageEntrance.vue")
      }, {
        path: "/separate-enrollment",
        meta: {
          title: "单招练习",
          visible: true
        },
        component: () => import("@/views/ZPractise/ZSeparateEnrollment.vue")
      },
      {
        path: "/exam-online",
        meta: {
          title: "在线考试",
          visible: true
        },
        component: () => import("@/views/ZPractise/ZExam.vue")
      }, {
        path: "/homework",
        meta: {
          title: "班级作业",
          visible: true
        },
        component: () => import("@/views/ZPractise/ZHomework/ZHomework.vue")
      }, {
        path: "/coding-online",
        meta: {
          title: "在线编程",
          visible: true
        },
        component: () => import("@/views/ZPractise/ZCoding.vue")
      },

    ]
  },
  {
    path: "/student-info",
    component: Layout,
    meta: {
      title: "学生信息",
      visible: true,
      icon: 'SolutionOutlined'
    },
    children: [
      {
        path: "/student-status",
        meta: {
          title: "学籍信息",
          visible: true
        },
        component: () => import("@/views/ZStudent/statusInfo/ZStudentInfo.vue")
      },
      {
        path: "/student-evaluate",
        meta: {
          title: "学生评价",
          visible: true
        },
        component: () => import("@/views/ZStudent/ZStudentEvaluate.vue")
      },
      {
        path: "/student-mental-health",
        meta: {
          title: "心理健康",
          visible: true
        },
        component: () => import("@/views/ZStudent/mental-health/ZStudentMentalHealth.vue")
      },
    ]
  },
  {
    path: "/teacher-info",
    component: Layout,
    meta: {
      title: "教师信息",
      visible: true,
      icon: 'TeamOutlined'
    },
    children: [
      {
        path: "/paper-composition",
        meta: {
          title: "组卷作业",
          visible: true
        },
        component: () => import("@/views/ZTeacher/paper-composition/ZPaperComposition.vue")
      },
      {
        path: "/teacher-status",
        meta: {
          title: "教师信息管理",
          visible: true
        },
        component: () => import("@/views/ZTeacher/info/ZTeacherInfo.vue")
      },
      {
        path: "/teacher-honor",
        meta: {
          title: "荣誉管理",
          visible: true
        },
        component: () => import("@/views/ZTeacher/honor/ZTeacherHonor.vue")
      },
      {
        path: "/teacher-evaluate",
        meta: {
          title: "教师评价",
          visible: true
        },
        component: () => import("@/views/ZTeacher/evaluate/ZTeacherEvaluate.vue")
      },

    ]
  },
  {
    path: "/department",
    component: Layout,
    meta: {
      title: "处室信息",
      visible: true,
      icon: 'BookOutlined'
    },
    children: [
      {
        path: "/personal-management",
        meta: {
          title: "人事管理",
          visible: true
        },
        component: () => import("@/views/ZDepartment/personal-management/ZPersonalManagement.vue")
      },
      {
        path: "/department-management",
        meta: {
          title: "处室管理",
          visible: true
        },
        component: () => import("@/views/ZDepartment/department-management/ZDepartmentManagement.vue")
      },
      {
        path: "/mental-health-management",
        meta: {
          title: "心理健康管理",
          visible: true
        },
        component: () => import("@/views/ZDepartment/mental-health-management/ZMentalHealthManagement.vue")
      },
      {
        path: "/teacher-evaluate-management",
        meta: {
          title: "教师评价管理",
          visible: true
        },
        component: () => import("@/views/ZDepartment/teacher-evaluate-management/ZTeacherEvaluateManagement.vue")
      },

    ]
  },
  // {
  //     path: "/",
  //     component: Layout,
  //     redirect: "/personal",
  //     meta: {
  //         title: "个人中心",
  //         visible: true
  //     }, children: [
  //         {
  //             path: "/personal",
  //             component: () => import("@/views/GPersonal/index.vue"),
  //             meta: {
  //                 title: "个人中心",
  //                 visible: true
  //             }
  //         }]
  // }
  {
    path: "/system",
    component: Layout,
    meta: {
      title: "系统管理",
      visible: true,
      icon:'SettingOutlined'
    },
    children: [
      {
        path: "/system/user",
        component: () => import("@/views/system/ZUserPage.vue"),
        meta: {
          title: "用户管理",
          visible: true
        }
      },
      {
        path: "/system/role",
        component: () => import("@/views/system/ZRolePage.vue"),
        meta: {
          title: "角色管理",
          visible: true
        }
      },
      {
        path: "/system/menu",
        component: () => import("@/views/system/ZMenuPage.vue"),
        meta: {
          title: "菜单管理",
          visible: true
        }
      },
      {
        path: "/system/file",
        component: () => import("@/views/system/ZFilePage.vue"),
        meta: {
          title: "文件管理",
          visible: true
        }
      },
      {
        path: "/system/dept",
        component: () => import("@/views/system/ZDeptPage.vue"),
        meta: {
          icon: 'SettingFilled',
          title: "部门管理",
          visible: true
        }
      },
      {
        path: "/system/dict",
        component: () => import("@/views/system/ZDictPage.vue"),
        meta: {
          title: "字典管理",
          visible: true
        }
      },
      {
        path: "/system/dict/:id",
        name: "DictData",
        component: () => import("@/views/system/ZDictDataPage.vue"),
        meta: {
          title: "字典数据",
          visible: false
        }
      },
    ]
  },
  {
    path: "/monitor",
    component: Layout,
    meta: {
      title: "系统监控",
      visible: true,
      icon:'FundOutlined'
    },
    children: [
      {
        path: "/monitor/redis",
        component: () => import("@/views/monitor/ZRedisPage.vue"),
        meta: {
          title: "redis",
          visible: true
        }
      },
      {
        path: "/monitor/login-log",
        component: () => import("@/views/monitor/ZLoginLogPage.vue"),
        meta: {
          title: "登陆日志",
          visible: true
        }
      },
      {
        path: "/monitor/operate-log",
        component: () => import("@/views/monitor/ZOperateLogPage.vue"),
        meta: {
          title: "操作日志",
          visible: true
        }
      },
    ]
  }
]

export default dynamicRoutes;